import { useEffect, useRef, useState } from 'react';

// A button that opens a short list of choices. Replaces the framework dropdown, and behaves the
// way a menu is expected to: closes on Escape, on a click outside, and after a choice is made,
// and reports its state to assistive technology.
export default function Menu({ label, trigger, className = '', children }) {
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;

    const onPointerDown = event => {
      if (!containerRef.current?.contains(event.target)) setOpen(false);
    };
    const onKeyDown = event => {
      if (event.key === 'Escape') setOpen(false);
    };

    document.addEventListener('pointerdown', onPointerDown);
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('pointerdown', onPointerDown);
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [open]);

  return (
    <div className={`menu ${className}`.trim()} ref={containerRef}>
      <button
        type="button"
        className="menu-trigger btn"
        aria-label={label}
        aria-expanded={open}
        aria-haspopup="true"
        onClick={() => setOpen(value => !value)}
      >
        {trigger}
      </button>
      {open && (
        <div className="menu-list dropdown-menu" role="menu" onClick={() => setOpen(false)}>
          {children}
        </div>
      )}
    </div>
  );
}

export function MenuItem({ onClick, selected, label, children }) {
  return (
    <button type="button" role="menuitemradio" aria-checked={selected} aria-label={label}
      className="menu-item dropdown-item" onClick={onClick}>
      {children}
    </button>
  );
}
